import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import User from './../../components/User/User.js';
import { UserContext, CommonContext } from './../../contexts/constant/ActionTypes';

const UserPage = ({history, match}) => {
    const userContext = useContext(UserContext);
    const commonContext = useContext(CommonContext);

	return (
        <User 
            history={history} 
            match={match}
            userContext={userContext}
            commonContext={commonContext}
        />
	);
}

UserPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

UserPage.defaultProps = {
    history: {},
    match: {}
};

export default UserPage;



// WEBPACK FOOTER //
// ./containers/UserPage/UserPage.js